import { BaseComunicationProvider } from './basecomunication';
import { GameGroup } from '../entities/gamegroup';
import { Rank } from '../entities/rank';
import { AdminGameGroup } from '../entities/adminGameGroup';
import { Injectable } from '@angular/core';

@Injectable()
export class ContestService extends BaseComunicationProvider {
    public address: string = "ContestHandler.ashx"; 

    GetGamesToBet() {
        return new Promise((resolve, reject) => {
            this.sendDataHttp("GetGamesToBet", JSON.stringify(""))
              .then(data => {
                var json: any = data;
                resolve(<GameGroup[]>json.Item);
              }).catch((err) => {
                  reject(err);
              });
            });
    };

    GetGames() {
      return new Promise((resolve, reject) => {
          this.sendDataHttp("GetGames", JSON.stringify(""))
            .then(data => {
              var json: any = data;
              resolve(<AdminGameGroup[]>json.Item);
            }).catch((err) => {
                reject(err);
            });
          });
  };

    GameGroupReplacer(key: string, value: any): any {
      if ((key=="Schedule") || (key=="LastChangedDate") || (key=="TicketDate")) return undefined;
      else return value;
    }

    DoBet(games: GameGroup[]) {
      return new Promise((resolve, reject) => {
        this.sendDataHttp("DoBet", JSON.stringify(games, this.GameGroupReplacer))
          .then(data => {
            var json: any = data;
            resolve(<GameGroup[]>json.Item);
          }).catch((err) => {
              reject(err);
          });
        });
    }

    ChangeGames(games: AdminGameGroup[]) {
      return new Promise((resolve, reject) => {
        this.sendDataHttp("ChangeGames", JSON.stringify(games, this.GameGroupReplacer))
          .then(data => {
            var json: any = data;
            resolve(<AdminGameGroup[]>json.Item);
          }).catch((err) => {
              reject(err);
          });
        });
    }

    prepareAudith() {
      return new Promise((resolve, reject) => {
        this.sendDataHttp("PrepareAudith", JSON.stringify(""))
          .then(data => {
            var json: any = data;
            resolve(<string>json.Item);
          }).catch((err) => {
              reject(err);
          });
        });
    }

    getRank(groupId: number) {
      return new Promise((resolve, reject) => {
        this.sendDataHttp("GetRank", JSON.stringify({Value: groupId}))
          .then(data => {
            var json: any = data;
            resolve(<Rank[]>json.Item);
          }).catch((err) => {
              reject(err);
          });
        });
    }

    getGamesToStatment(ticketId: number, gameGroupId: number) {
      return new Promise((resolve, reject) => {
        this.sendDataHttp("GetGamesToStatment", JSON.stringify({TicketId: ticketId, GameGroupId: gameGroupId}))
          .then(data => {
            var json: any = data;
            resolve(<GameGroup>json.Item);
          }).catch((err) => {
              reject(err);
          });
        });
    }

    getRankGroup(ticketGroupId: number, groupId: number) {
      return new Promise((resolve, reject) => {
        this.sendDataHttp("CreateAndGetGroupRank", JSON.stringify({TicketGroupId: ticketGroupId, GroupId: groupId}))
          .then(data => {
            var json: any = data;
            resolve(<Rank[]>json.Item);
          }).catch((err) => {
              reject(err);
          });
        });
    }

    getGroups() {
      return new Promise((resolve, reject) => {
        this.sendDataHttp("GetGroups", JSON.stringify(""))
          .then(data => {
            var json: any = data;
            resolve(<GameGroup[]>json.Item);
          }).catch((err) => {
              reject(err);
          });
        });
    }
}


// WEBPACK FOOTER //
// ./src/providers/contest.ts